import React, { useEffect, useState } from 'react';
import { Alert, Modal, Sentiments, Sizes } from '@sede-enterprise/shell-ds-react-framework';
import { APIErrorResponseInterface } from '../../helpers/InterfacesConstants';

const ResponseErrorModal = (props: {errorDetails: APIErrorResponseInterface | null | undefined, isOpen: boolean, onModalClose : ()=>void}) => {
    const [open, setOpen] = useState(false);
    useEffect(() => {
        setOpen(props.isOpen);
	},[props.isOpen]);

    const cancel = () =>{
        setOpen(false);
        props.onModalClose()
    }
    return (
        <Modal open={open} onClose={() => {cancel()}}>
            <Alert iconVisibility={false}  sentiment={Sentiments.Negative} size={Sizes.Large} label='Error'>
                {props.errorDetails?.message}
            </Alert>
            {props.errorDetails?.traceId && `Ref ID: ${props.errorDetails.traceId}`}
        </Modal>
    )
}

export default ResponseErrorModal;